import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { App } from './App'

// Office.js must be initialized before rendering the React tree.
// Office.onReady resolves immediately in non-Office environments (dev browser).
Office.onReady(() => {
  const container = document.getElementById('root')
  if (!container) throw new Error('Root element #root not found')
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>
  )
})
